import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CategoryApiClientSettingEffects } from './category-api-client-setting.effects';
import { categoryApiClientSettingReducer } from './category-api-client-setting.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('categoryApiClientSetting', categoryApiClientSettingReducer),
    EffectsModule.forFeature([CategoryApiClientSettingEffects]),
  ],
  providers: [],
})
export class CategoryApiClientSettingStoreModule {}
